import React, { useState, useCallback } from "react";
import MainMenu from "../Modal/Menu/MainMenu";
import MainAuthButton from "../Modal/Buttons/AuthButtons/MainAuthButton";

export default function MenuTrigger({ updateProfile }: any) {
  const [open, setOpen] = useState(false);

  const toggleOpen = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  return (
    <>
      <MainAuthButton onClick={toggleOpen} />
      <MainMenu
        isOpen={open}
        onClose={toggleOpen}
        updateProfile={updateProfile}
      />
    </>
  );
}